import { getAzureUser } from "../User/User";

// Update label and url on runtime for organization, application and portal
export async function UpdateRuntimeforLabelandUrlChange(
    type,
    context,
    orgId,
    instanceId,
    portalId,
    data
) {
    let accessToken = localStorage.getItem("accessToken")
    var requestOptions = {
        method: "POST",
        headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    };

    let user = await getAzureUser(context)

    var baseURL = process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/UpdateRuntime?";
    var searchParams = new URLSearchParams();

    searchParams.append("type", type);
    searchParams.append("userId", user.oid);
    searchParams.append("orgId", orgId);

    if (type === "Application") {
        searchParams.append("appId", instanceId);
    } else if (type === "Portal") {
        searchParams.append("appId", instanceId);
        searchParams.append("portalId", portalId);
    }

    let requestURL = baseURL + searchParams.toString();

    let request = await fetch(requestURL, requestOptions);
    let result = await request.json();
    return result;
}

// Assign subscription to organization on runtime
export async function assignSubscriptionToOrganizationOnRuntime(organizationId, subscriptionId) {
    let accessToken = localStorage.getItem("accessToken")
    let url = process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/AssignSubscriptionToOrg"
    let requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            orgid: organizationId,
            subsid: subscriptionId,
            "tokentype": "accesstoken"
        }
    }
    let request = await fetch(url, requestOptions)
    let response = await request.json()
    return response
}

//update/create subscription on runtime
export async function updateSubscriptionOnRuntime(data) {
    const accessToken = localStorage.getItem("accessToken");
    await fetch(process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/AddUpdateSubscriptionType", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + accessToken,
            "tokentype": "accesstoken"
        },
        body: JSON.stringify(data)
    })
}



export async function updateAllowEditAndPublishOnRuntime(appId, allowEditAndPublish) {
    const accessToken = localStorage.getItem("accessToken");
    const url = process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/ModifyAppDesignerModelAccess"
    const request = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + accessToken,
            "tokentype": "accesstoken"
        },
        body: JSON.stringify({
            "appId": appId,
            "disabled": allowEditAndPublish
        })
    })
    const response = await request.json()
    return response
}

export async function AddUserToApplicationBySignupId(signupIdentity, userId) {
    const accessToken = localStorage.getItem("accessToken");
    const url = process.env.REACT_APP_RUNTIME_API_URL + "/api/user/AddUserToApplicationBySignupId"
    const request = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + accessToken,
            "tokentype": "accesstoken",
            signupidentity: signupIdentity,
            userid: userId
        }
    })
    const response = await request.json()
    return response
}

// remove user from organization on runtime
export async function removeUserFromOrganizationOnRuntime(organizationId, azureId, email) {
    let accessToken = localStorage.getItem("accessToken")
    let url = process.env.REACT_APP_RUNTIME_API_URL + "/api/user/RemoveUserFromOrg"
    let requestOptions = {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            "orgid": organizationId,
            "userid": azureId,
            "email": email
        }
    }
    let response = await fetch(url, requestOptions)
    response = await response.json()
    return response
}

